var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/user-solid",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,14.2222222 C18.7401549,14.2222222 23,17.0027778 23,22.7777778 L23,22.7777778 L1,22.7777778 C1,17.0027778 5.25984505,14.2222222 12,14.2222222 Z M12,2 C14.6888889,2 16.8888889,4.2 16.8888889,6.88888889 C16.8888889,9.57777778 14.6888889,11.7777778 12,11.7777778 C9.31111111,11.7777778 7.11111111,9.57777778 7.11111111,6.88888889 C7.11111111,4.2 9.31111111,2 12,2 Z",
  id: "\\uD83C\\uDFA8-Icon-Color",
  fill: "#32373C",
  fillRule: "nonzero"
}))));
export { SvgUserSolid as ReactComponent };
export default __webpack_public_path__ + "images/user-solid.svg";